import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ROLES } from '@config/authentication';
import { PrivateRoute, ErrorBoundary } from '@organisms';
import {
  LoginPage,
  ForgotPasswordPage,
  AdminPage,
  DashboardConferencesPage,
  DashboardTranscriptsPage,
  ConferenceCreationPage,
  OrganizationCreationPage,
  OrganizationEditPage,
  TranscriptCreationPage,
  OrganizationsPage,
  ConferenceEditPage,
  ConferenceViewPage,
  TranscriptAdminPreviewPage,
  SettingsPage,
  TranscriptViewPage,
  LoginWithToken,
  PhoneNumbersPage,
  TwoFactorAuthPage,
  BlockedAttendeesPage,
  NotFound,
  NoPermission,
} from '@pages';

import { history } from './redux/enhancers/middlewares';
import store from './redux/store';
import theme from './theme';
import ConnectedIntlProvider from './Intl';
import './style.css';

const Root = () => (
  <Provider store={store}>
    <ConnectedIntlProvider>
      <MuiThemeProvider muiTheme={theme}>
        <ErrorBoundary>
          <ConnectedRouter history={history}>
            <Switch>
              <PrivateRoute exact path="/" component={DashboardConferencesPage} />
              <PrivateRoute
                accessLevel={ROLES.ATTENDEE}
                exact
                path="/transcripts"
                component={DashboardTranscriptsPage}
              />
              <Route path="/transcripts/ai/:id" component={TranscriptViewPage} />
              <Route path="/transcripts/:id" component={TranscriptViewPage} />
              <Route path="/login/:userId/:token" component={LoginWithToken} />
              <Route path="/login" component={LoginPage} />
              <Route
                path="/forgot-password/:userId?/:token?"
                component={ForgotPasswordPage}
              />
              <Route path="/two-factor-auth" component={TwoFactorAuthPage} />
              <Route path="/phone-numbers" component={PhoneNumbersPage} />
              <PrivateRoute
                accessLevel={ROLES.SUPER_ADMIN}
                path="/admin"
                component={AdminPage}
              />
              <PrivateRoute
                accessLevel={ROLES.ATTENDEE}
                path="/blocked-attendees"
                component={BlockedAttendeesPage}
              />
              <PrivateRoute path="/conference/new" component={ConferenceCreationPage} />
              <PrivateRoute
                accessLevel={ROLES.SUPER_ADMIN}
                path="/organization/new"
                component={OrganizationCreationPage}
              />
              <PrivateRoute
                accessLevel={ROLES.SUPER_ADMIN}
                path="/organization/edit/:id"
                component={OrganizationEditPage}
              />
              <PrivateRoute path="/transcript/new" component={TranscriptCreationPage} />
              <PrivateRoute
                accessLevel={ROLES.SUPER_ADMIN}
                path="/organizations"
                component={OrganizationsPage}
              />
              <PrivateRoute
                accessLevel={ROLES.ATTENDEE}
                path="/transcript/view/:id"
                component={TranscriptAdminPreviewPage}
              />
              <PrivateRoute
                accessLevel={ROLES.ATTENDEE}
                path="/transcript/ai/view/:id"
                component={TranscriptAdminPreviewPage}
              />
              <PrivateRoute path="/conference/edit/:id" component={ConferenceEditPage} />
              <PrivateRoute path="/conference/view/:id" component={ConferenceViewPage} />
              <PrivateRoute path="/settings" component={SettingsPage} />
              <Route
                exact
                path="/no-permission"
                component={() => <NoPermission showGoBack={false} />}
              />
              <Route path="/" component={NotFound} />
            </Switch>
          </ConnectedRouter>
        </ErrorBoundary>
      </MuiThemeProvider>
    </ConnectedIntlProvider>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./index.js